// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__3k590O1f","tab":"Tabs_tab__wFDA1Zuf","active":"Tabs_active__iQKyfPvy"};